import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import categoryPageQuery from './query.graphql';

const Category = loadable(
  () => import(/* webpackChunkName: "category" */ './category'),
  {
    fallback: <Loader />,
  }
);

Category.graphQL = categoryPageQuery;

Category.variables = ({
  id,
  offset,
  campaignId,
  filterId,
  sort,
  direction,
  brand,
  compare,
}) => ({
  id,
  offset: parseInt(offset, 10) || 0,
  campaignId,
  categoryDealId: [id],
  filterId,
  sort,
  direction,
  brand,
  compareIds: compare ? compare.split(',') : ['_core_'],
  isServices: id === 'v1004',
});

Category.group = ({ name, variables }) => {
  const groupVariables = variables
    ? Object.keys(variables)
        .filter(key => ['id', 'brand', 'filterId', 'offset'].includes(key))
        .filter(key => variables[key])
        .map(key => variables[key])
    : [];

  return `${name}_${groupVariables.join('_')}_${variables.compareIds.join(
    ':'
  )}`;
};

export default Category;
